<main>
  <router-outlet></router-outlet>
</main>
<app-svg-sprite-def class="d-none"></app-svg-sprite-def>
